import dayjsImport from "./auth-service-tools36.js";
import timezone from "./auth-service-tools38.js";
import utc from "./auth-service-tools37.js";
dayjsImport.extend(utc);
dayjsImport.extend(timezone);

function getTimezoneOffset(date, timezone2) {
  if (timezone2) {
    return dayjsImport(date).tz(timezone2).utcOffset() + date.getTimezoneOffset();
  }

  return 0;
}

export { getTimezoneOffset };